import { useMemo, type CSSProperties } from "react";
import { range, rand, pick } from "../utils/random";
import type { EffectProps } from "./types";

const SPARKLES = ["✦", "✧", "✨", "⋆", "★"];

export function SparkleStars({ count = 70 }: EffectProps = {}) {
  const sparkles = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        char: pick(SPARKLES),
        left: `${rand(0, 100)}vw`,
        top: `${rand(0, 100)}vh`,
        size: `${rand(14, 32)}px`,
        twinkleDuration: `${rand(1.6, 3.6)}s`,
        delay: `${rand(-3, 0)}s`,
        hue: rand(330, 50),
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {sparkles.map(s => (
        <span
          key={s.id}
          className="fx-particle fx-sparkle"
          style={
            {
              left: s.left,
              top: s.top,
              fontSize: s.size,
              color: `hsl(${s.hue}, 90%, 75%)`,
              animationDuration: s.twinkleDuration,
              animationDelay: s.delay,
            } as CSSProperties
          }
        >
          {s.char}
        </span>
      ))}
    </div>
  );
}
